import React from 'react';
import styled from 'styled-components';
import { breakpoint, theme } from '../../theme';
import { BodyText, Heading } from '../typography';
import { GavelIcon, SupportIcon, TimeIcon } from '../../assets';

export type PropositionCardProps = {
  iconImage: string;
  heading: string;
  subHeading: string;
};

const CardWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  background-color: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.neutrals.solidGrays[6]};
  border-radius: ${theme.spacings[2].rem};
  ${breakpoint('lg')`
    flex-basis:33.33%;
  `}
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${theme.spacings[5].rem} ${theme.spacings[4.75].rem};
`;

const Header = styled(Heading).attrs({ size: 4 })`
    ${theme.typography.headings[4]['md-xl']}
    font-weight: bold;
    margin-top:${theme.spacings[4].rem};
    margin-bottom:${theme.spacings[2].rem};
})`;

const SubHeader = styled(BodyText).attrs({ size: 'md' })``;

const setIcon = (icon: string) => {
  switch (icon) {
    case 'Gavel':
      return <GavelIcon width={56} />;
    case 'Support':
      return <SupportIcon width={56} />;
    case 'Time':
      return <TimeIcon width={56} />;
    default:
      return null;
  }
};

export const PropositionCard: React.FC<PropositionCardProps> = ({
  heading,
  subHeading,
  iconImage,
}) => {
  return (
    <CardWrapper>
      <CardContainer>
        {setIcon(iconImage)}
        <Header>{heading}</Header>
        <SubHeader>{subHeading}</SubHeader>
      </CardContainer>
    </CardWrapper>
  );
};
